import { render, staticRenderFns } from "./BotPages.vue?vue&type=template&id=77732532&scoped=true"
import script from "./BotPages.vue?vue&type=script&lang=js"
export * from "./BotPages.vue?vue&type=script&lang=js"
import style0 from "./BotPages.vue?vue&type=style&index=0&id=77732532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77732532",
  null
  
)

export default component.exports